// Small synchronous head entry: workspace appearance is ready before the body
// renders. Keep CodeMirror and editor UI out of this bundle.
import {installStylesheet} from "./branding/stylesheet"
installStylesheet()
